import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-performance-section-my-reviews',
  templateUrl: './performance-section-my-reviews.component.html',
  styleUrls: ['./performance-section-my-reviews.component.scss']
})
export class PerformanceSectionMyReviewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
